import apiRxjs from 'util/api.rxjs';
import { Observable } from 'rxjs';
import { Payload } from 'ducks/settings';

const emojiesBackend = 'https://emoji.yandex-team.ru';

export type EmojiesData = string;
export interface SendEmoji {
  (emoji: EmojiesData): Observable<Payload>
}
export interface EmojiesApi {
    sendEmojiRequest: SendEmoji
    pingEmojiRequest: () => Observable<Payload>
}

export const sendEmojiRequest = (emoji: string) =>
    apiRxjs.post(`${emojiesBackend}/reaction?emoji=${emoji}`, { credentials: 'include' });

export const pingEmojiRequest = () =>
    apiRxjs.get(`${emojiesBackend}/liveness`, { credentials: 'include' });

export const emojiesApi = {
    sendEmojiRequest,
    pingEmojiRequest,
};

export default emojiesApi;
